/**
 * @file
 * Patria module video click-to-play functionality.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.moduleVideo = {
    attach: () => {
      const moduleClass = '.paragraph--type--module-video';

      if ($(moduleClass).length === 0) {
        return;
      }

      document.querySelectorAll(`${moduleClass} .js-video-thumbnail`).forEach(function (thumbnail) {
        if (thumbnail.dataset.initialized) {
          return;
        }
        thumbnail.dataset.initialized = true;

        thumbnail.addEventListener('click', function () {
          const wrapper = this.closest('.video-wrapper');
          const iframe = wrapper.querySelector('.js-video-iframe');
          iframe.src = iframe.dataset.src;
          iframe.style.display = '';
          this.style.display = 'none';
        });
      });
    }
  };

})(jQuery, Drupal);
